import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import rootReducers from "./reducers";
import { taxyApis } from "../app/services/taxy";
import { createOrdersApi } from "../app/services/lily";

const middleware = [thunk].concat(
  createOrdersApi.middleware,
  taxyApis.middleware
);

const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat(...middleware),
});

export default store;
